import { Component, Input, inject } from '@angular/core';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
  selector: 'lib-edi-navigation-buttons',
  templateUrl: './edi-navigation-buttons.component.html',
  styleUrls: ['./edi-navigation-buttons.component.css'],
  standalone: false
})
export class EdiNavigationButtonsComponent {
  @Input() baseRoute: string;

  public ediNavigationService = inject(EdiNavigationService);
}
